import { formatString } from 'xen/helpers/format';
export const getSalesPersonName = (salesPerson) => {
    const { firstName, lastName, emailAddress } = salesPerson.user;
    return formatString.squeezeValues([firstName, lastName], ' ') || emailAddress.trim();
};
